function asSslMetadata(value) {
    if (!value || typeof value !== "object") {
        return null;
    }
    const candidate = value;
    if (typeof candidate.validToUtc !== "string") {
        return null;
    }
    if (typeof candidate.daysRemaining !== "number") {
        return null;
    }
    if (candidate.status !== "ok" && candidate.status !== "warning" && candidate.status !== "expired") {
        return null;
    }
    return {
        validToUtc: candidate.validToUtc,
        daysRemaining: candidate.daysRemaining,
        status: candidate.status,
    };
}
export function getSslTooltipText(metadata) {
    const ssl = asSslMetadata(metadata === null || metadata === void 0 ? void 0 : metadata.ssl);
    if (!ssl) {
        return undefined;
    }
    const validTo = new Date(ssl.validToUtc).toLocaleString("sv-SE");
    if (ssl.status === "expired") {
        return `SSL-certifikatet gick ut ${validTo}.`;
    }
    return `SSL-certifikatet är giltigt till ${validTo} (${ssl.daysRemaining} dagar kvar).`;
}
